import React from "react";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/material";

// Square loader animation
const loaderAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

function SquareLoader({ sx = {} }) {
  // Square loader positions and delays - equal gaps between squares
  // Each square is 10px wide, adding 5px gaps between squares horizontally and vertically
  const squareConfigs = [
    { id: "sq1", marginTop: "-15px", marginLeft: "-15px", delay: "0s" },
    { id: "sq2", marginTop: "-15px", marginLeft: "0px", delay: "75ms" },
    { id: "sq3", marginTop: "-15px", marginLeft: "15px", delay: "150ms" },
    { id: "sq4", marginTop: "0px", marginLeft: "-15px", delay: "225ms" },
    { id: "sq5", marginTop: "0px", marginLeft: "0px", delay: "300ms" },
    { id: "sq6", marginTop: "0px", marginLeft: "15px", delay: "375ms" },
    { id: "sq7", marginTop: "15px", marginLeft: "-15px", delay: "450ms" },
    { id: "sq8", marginTop: "15px", marginLeft: "0px", delay: "525ms" },
    { id: "sq9", marginTop: "15px", marginLeft: "15px", delay: "600ms" },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        width: "50px",
        height: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...sx,
      }}
    >
      {squareConfigs.map((config) => (
        <Box
          key={config.id}
          sx={{
            background: "#ddd",
            width: "10px",
            height: "10px",
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: config.marginTop,
            marginLeft: config.marginLeft,
            animation: `${loaderAnimation} 675ms ease-in-out ${config.delay} infinite alternate`,
          }}
        />
      ))}
    </Box>
  );
}

export default SquareLoader;
